import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EicPrefixedExcelxValidator {
    /**
   * Function to control filename is prefixed with a valid EIC string and file-extension is xlsx (excelx)
   *
   * @returns
   */
    static areFileNamesEicPrefixedAndExcel(): ValidatorFn {

        return (control: AbstractControl): { [key: string]: any } | null => {
            const filesNamesWithErrors: string[] = [];
            const fileList = (control.value as File[] | null);
            const files = fileList || [];
            if (files.length > 0) {
                let eicSyntaxErrors: string[] = [];
                let eicFileNameExtensionErrors: string[] = [];
                let duplicateFileNames: string[] = [];

                for (const file of files) {
                    applySyntaxAndFileExtensionCheck(file, filesNamesWithErrors, eicSyntaxErrors, eicFileNameExtensionErrors);
                }

                let remainingFiles = files.filter(file => !filesNamesWithErrors.includes(file.name));
                this.applyDuplicateCheck(remainingFiles, filesNamesWithErrors, duplicateFileNames);

                if (filesNamesWithErrors && filesNamesWithErrors.length > 0 || duplicateFileNames && duplicateFileNames.length > 0) {
                    return {
                        eicErrors: {
                            'invalidFiles': filesNamesWithErrors,
                            'duplicateFileNames': duplicateFileNames,
                            'eicSyntaxErrors': eicSyntaxErrors,
                            'eicFileTypeErrors': eicFileNameExtensionErrors,
                        },
                    };
                } else {
                    return null;
                }
            }

            return null;
        };

        function applySyntaxAndFileExtensionCheck(file: File, filesNamesWithErrors: string[], eicSyntaxErrors: string[], eicFileTypeErrors: string[]) {
            // check if _ exists as required spacer
            const indexOfLowDashInFilename = file.name.indexOf('_');
            if (indexOfLowDashInFilename == -1) {
                filesNamesWithErrors.push(file.name);
                eicSyntaxErrors.push(file.name);
                return;
            }

            // check if file-extension is .xlsx
            if (!file.name.endsWith('.xlsx')) {
                filesNamesWithErrors.push(file.name);
                eicFileTypeErrors.push(file.name);
                return;
            }

            // check EIC-number length constraint
            const eicCandidate = file.name.substring(0, indexOfLowDashInFilename);
            if (eicCandidate.length < 16) {
                filesNamesWithErrors.push(file.name);
                eicSyntaxErrors.push(file.name);
            } else if (eicCandidate.length > 16) {
                filesNamesWithErrors.push(file.name);
                eicSyntaxErrors.push(file.name);
            }
        }
    };

    private static applyDuplicateCheck(remainingFiles: File[], filesNamesWithErrors: string [], duplicateFileNames: string[]) {
        while (remainingFiles.length != 0) {
            let file = remainingFiles.pop();
            let eicOfFile = file.name.substring(0, 16);
            let duplicate = remainingFiles.find(nextFile => {
                if (nextFile.name.startsWith(eicOfFile)) return nextFile;
            });

            if (duplicate) {
                duplicateFileNames.push(file.name);
                filesNamesWithErrors.push(file.name);
                duplicateFileNames.push(duplicate.name);
                filesNamesWithErrors.push(duplicate.name);
                remainingFiles = remainingFiles.filter(f => f != duplicate);
            }

        }
    }
}

